import { render } from "./ScoreDetails.vue?vue&type=template&id=9044f9b4"
import script from "./ScoreDetails.vue?vue&type=script&lang=js"
export * from "./ScoreDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__